import { motion, AnimatePresence } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';

import AdvtFullSize from './components/AdvtFullSize/AdvtFullSize';
import { MessagesList } from './components/MessagesList/MessagesList';

import bgPoster from './assets/images/bgPoster.png';

function App() {
  const {
    showedMessages,
    speed,
    currentState,
    activeSharkRight,
    activeSharkLeft,
  } = useCarousel();

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      {/*чтобы не было белого фона при смене стадий и интерактивов */}
      <img src={bgPoster} alt="" className="bgImg" />

      <AnimatePresence mode="popLayout">
        {currentState === 'S1' && (
          <motion.div
            key="advt"
            initial={{ y: 0 }}
            exit={{ y: '170%' }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
            className="motionBlock"
          >
            <AdvtFullSize />
          </motion.div>
        )}

        {['S2'].includes(currentState) && (
          <motion.div
            key="messageList"
            className="motionBlock"
            initial={{ y: 0 }}
            exit={{ y: '170%' }}
            transition={{ duration: 0.6, ease: 'easeOut' }}
          >
            <MessagesList
              key="msgList"
              messages={showedMessages}
              currentState={currentState}
              speed={speed || 0}
              activeSharkRight={activeSharkRight}
              activeSharkLeft={activeSharkLeft}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
